<template>
  <div>
    <div class="row text-white inner-row" style="background: #bbb970">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Дата'" :value="convertDate(object.date)"></simple-row>
    <simple-row :name="'Дата закрытия договора'" :value="convertDate(object.closeDate)"></simple-row>

    <doc-view v-if="!editDocument" :item="{object: object.document, id: object.document.id}"
              @toEdit="editDocument = true">
    </doc-view>
    <doc-edit v-else :item="{object: object.document, id: object.document.id}"
              :type="'document'"
              @updated="updateDoc"
              @toRow="editDocument = false" @toView="editDocument = false">
    </doc-edit>
    <br/>

    <contract-kits :item="item.object"></contract-kits>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";
 import ClientContracts from "@/nestedTables/ClientContracts";
 import ContractKits from "@/nestedTables/ContractKits";

 export default {
   components: {
     ContractKits,
     ClientContracts,
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showKits: false,
       editDocument: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     updateDoc(doc) {
       this.item.object.document = doc;
     },
     async update() {
       this.item.object = await this.$repo.get(this.object.id, 'contract');
       this.object = this.item.object;
     }
   }
 }
</script>
<style>
</style>
